import React from "react";
import {
    TableHead,
    TableRow,
    TableCell,
    Checkbox,
} from "@mui/material";
import { useLanguage } from '../../../../context/LanguageContext';

interface ListTableHeaderProps {
    selectedCount: number;
    totalCount: number;
    onSelectAll: () => void;
}

const ListTableHeader = ({
    selectedCount,
    totalCount,
    onSelectAll,
}: ListTableHeaderProps) => {
    const { t } = useLanguage();

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        checked={selectedCount === totalCount && totalCount > 0}
                        indeterminate={selectedCount > 0 && selectedCount < totalCount}
                        onChange={onSelectAll}
                    />
                </TableCell>
                <TableCell>{t("pages.clients.importList.list")}</TableCell>
                <TableCell>{t("pages.clients.importList.importDate")}</TableCell>
                <TableCell align="center">{t("pages.clients.importList.accountCount")}</TableCell>
                <TableCell align="center">{t("pages.clients.importList.listType")}</TableCell>
                <TableCell align="center">{t("pages.clients.importList.details")}</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default ListTableHeader;
